<script lang="ts">
    import { writable } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import { sanchor, spath } from 'hydria/svelte_helpers'
    import { toLuxon } from 'hydria/utils/time'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'

    const LIMIT = 5

    interface Props {
        qText: string
    }

    let { qText }: Props = $props()

    // Search result from the server
    interface ISearchResult {
        items: Array<any>
        total_items: number
    }

    let results = writable([] as any[])

    let loading = $state(true)
    let updating = $state(false)
    let searchId = 0
    let searchQueryString: string = $state('')
    let totalItems: number = $state(0)
    function doSearch(text: string) {
        updating = true

        let sdata: { [key: string]: any } = { limit: LIMIT }
        if (text != '') sdata.text = text
        searchQueryString = `q=${encodeURIComponent(qText)}`

        searchId++
        ;((localSearchId) => {
            simpleFetch('GET', '/json/wdom-user/1/', { data: JSON.stringify(sdata) })
                .then((r) => {
                    if (localSearchId != searchId) {
                        // This result does not match the current search anymore
                        // and there should be another search in progress
                        console.warn('Received search result for an older search, ignoring')
                        return
                    }
                    loadSearchResult(r.data as ISearchResult)
                    updating = false
                })
                .catch((e) => {
                    console.error('Error loading search results:', e)
                    notify({ title: $_('Search'), text: $_('Failed to load search results'), type: 'danger' })
                    updating = false
                })
            if (loading) loading = false
        })(searchId)
    }

    let lastQs: string | undefined
    $effect(() => {
        // Doesn't really happen, but as a safety..
        if (qText && qText != lastQs) {
            lastQs = qText
            doSearch(qText)
        }
    })

    function loadSearchResult(data: ISearchResult) {
        let litems: any[] = []
        totalItems = data.total_items

        for (const item of data.items) {
            for (const key of ['ctime', 'mtime']) {
                if (item[key]) item[key] = toLuxon(item[key])
            }

            litems.push(item)
        }

        results.set(litems)
    }
</script>

<div class="card">
    <div class="card-title text-primary">{$_('Users')}</div>

    <div class="card-body">
        <table class="table table-striped mb-0" class:disabled-look={updating}>
            <thead>
                <tr>
                    <th class="col-md-5">{$_('Name')}</th>
                    <th>{$_('Email address')}</th>
                </tr>
            </thead>
            <tbody>
                {#if loading}
                    <tr>
                        <td colspan="2"><LoadingPattern pattern={['x']} /></td>
                    </tr>
                    <tr>
                        <td colspan="2"><LoadingPattern pattern={['x']} /></td>
                    </tr>
                {:else if !$results.length}
                    <tr>
                        <td colspan="2" class="text-center">Aucun résultat</td>
                    </tr>
                {:else}
                    {#each $results as item (item.id)}
                        <tr>
                            <td><a use:sanchor href={spath(`/wdom-user/${item.id}`)}>{item.metadata && item.metadata.name ? item.metadata.name : '<not set>'}</a></td>
                            <td>{item.email}</td>
                        </tr>
                    {/each}
                {/if}
            </tbody>
        </table>
    </div>
    {#if totalItems != null}
        <div class="card-footer">
            <div class="float-end">{$_('Total : {n}', { n: totalItems })}</div>
            <a use:sanchor href={spath(`/wdom-users?${searchQueryString}`)}>{$_('All results')}</a>
        </div>
    {/if}
</div>
